import { Box, Button, Typography } from "@mui/material";

const openEmailProvider = () => {
  const params = new URLSearchParams({
    to: "contact@flownect.com",
    subject: "Quote Support",
  });
  window.open(`https://mail.google.com/mail/?view=cm&fs=1&${params.toString()}`, "_blank");
};

export const QuoteActions = ({ quote, selectedTimes = {}, enableAdvanced, validSign = true, onAccept, onSupport, role }) => {
  if (!quote) return null;

  const isBasic = quote.type === "basic";
  const quoteIsAccepted = quote?.status === "approved";

  const servicesRequiringTime =
    quote.services?.filter(
      (s) => s.eventPreferences?.eventConfig?.mode === "SINGLE_EXECUTION" || s.eventPreferences?.eventConfig?.mode === "REPETITIVE",
    ) || [];

  const requiresTimeSelection = servicesRequiringTime.length > 0;

  const allRequiredTimesSelected = isBasic || servicesRequiringTime.every((s) => selectedTimes[s.serviceUid]);

  const allTimesSelected = !requiresTimeSelection || allRequiredTimesSelected;

  const isBussiness = role === "business";

  const handleAccept = () => {
    if (!allTimesSelected) return;

    if (isBasic || !requiresTimeSelection) {
      onAccept?.({
        quoteId: quote.id,
        status: "approved",
      });
      return;
    }

    const servicesPayload = servicesRequiringTime.map((s) => ({
      uid: s.serviceUid,
      eventTime: selectedTimes[s.serviceUid],
    }));

    onAccept?.({
      quoteId: quote.id,
      status: "approved",
      services: servicesPayload,
    });
  };

  return (
    <Box
      sx={{
        mt: 4,
        display: "flex",
        justifyContent: "center",
        gap: 2,
        flexWrap: "wrap",
      }}
    >
      <Button
        variant="contained"
        onClick={handleAccept}
        disabled={!allTimesSelected || quoteIsAccepted || !validSign || isBussiness}
        sx={{
          px: 5,
          py: 1.25,
          borderRadius: 2,
          textTransform: "none",
          fontWeight: 800,
          boxShadow: "none",
          backgroundColor: quoteIsAccepted ? "#CBD5E1" : !allTimesSelected && !isBasic ? "#CBD5E1" : "#FB8E00",
          color: "#FFFFFF",
          "&:hover": {
            backgroundColor: quoteIsAccepted ? "#CBD5E1" : !allTimesSelected && !isBasic ? "#CBD5E1" : "#E67F00",
            boxShadow: "none",
          },
        }}
      >
        {isBussiness && !quoteIsAccepted ? "Wait for the client to accept" : quoteIsAccepted ? "Already Approved" : "Accept Quote"}
      </Button>

      {enableAdvanced && (
        <Button
          variant="outlined"
          onClick={openEmailProvider}
          sx={{
            px: 5,
            py: 1.25,
            borderRadius: 2,
            textTransform: "none",
            fontWeight: 800,
            borderColor: "var(--fx-surface-border, #E2E8F0)",
            color: "var(--fx-surface-textsecondary, #64748B)",
            bgcolor: "var(--fx-surface-base, #FFFFFF)",
            "&:hover": {
              borderColor: "#FB8E00",
              color: "#FB8E00",
              bgcolor: "var(--fx-colors-warning-50, #FFF7ED)",
            },
          }}
          component="a"
          href="mailto:contact@flownect.com"
        >
          Contact Support
        </Button>
      )}

      {!allTimesSelected && !isBasic && !quoteIsAccepted && !isBussiness && (
        <Typography
          sx={{
            width: "100%",
            textAlign: "center",
            color: "error.main",
            mt: 1,
            fontSize: 14,
          }}
        >
          You must select a time for each service before accepting.
        </Typography>
      )}
      {!validSign && !isBussiness && (
        <Typography
          sx={{
            width: "100%",
            textAlign: "center",
            color: "error.main",
            mt: 1,
            fontSize: 14,
          }}
        >
          You must sign before accepting the quote
        </Typography>
      )}
    </Box>
  );
};
